import _ from "lodash";
import {SERVICE_IDS} from "./constants";

export function getCmpV2IdsFromServiceSet(tenants){
  let services = tenants?.map(item => {
    const {services} = item?.groupDetails
    const serviceSet = new Set();
    services?.countries.forEach(item => {
      item?.services.forEach(service => {
        serviceSet.add(service?.serviceId)
      })
    })
    return serviceSet.has(SERVICE_IDS.CMP) ? item.groupUuid : ""
  })
  services = services?.filter(item => item);
  return services
}


export function getPopulatedUserGroups(userGroupsV2, groupsV2) {
  if (_.isEmpty(userGroupsV2)) return []
  return userGroupsV2.map(item => {
    let userGroup = groupsV2.find(group => group?.tenantUuid === item?._tenantUuid)
    let clonedUserGroup = _.cloneDeep(userGroup)
    clonedUserGroup.groups = _.isEmpty(item?.groups) ? userGroup?.groups : userGroup?.groups.filter(usergroup => item?.groups.includes(usergroup?.uuid))
    return clonedUserGroup
  });
}
